import { useState } from 'react';

export enum ModalV3Id {
  POC_MODAL = 'poc-modal',
  PROJECT_SUMMARY_LIST = 'project-summary-list',
  ARCADIA_ACTIONS = 'arcadia-actions',
  ARCADIA_REMOVE_CONFIRMATION = 'arcadia-remove-confirmation',
  COUPON_ISSUANCE = 'coupon-issuance',
  PRICE_FILTER = 'price-filter',
  MANUFACTURERS_FILTER = 'manufacturers-filter',
  EXISTING_PROJECT = 'existing-project',
  ONBOARDING_TIMEOUT = 'onboarding-timeout',
  SAVINGS_EXPLAINER = 'savings-explainer',
}

export interface ModalV3Data {
  id: ModalV3Id;
  props?: Record<string, unknown>;
}

export interface ModalV3State {
  isOpen: boolean;
  current: ModalV3Data | null;
}

export const useModalV3 = () => {
  const [modalV3State, setModalV3State] = useState<ModalV3State>({
    isOpen: false,
    current: null,
  });

  const openModalV3 = (id: ModalV3Id, props?: Record<string, unknown>) => {
    setModalV3State({ isOpen: true, current: { id, props } });
  };

  const closeModalV3 = () => {
    setModalV3State((prev) => ({ isOpen: false, current: prev.current }));
  };

  return { modalV3State, openModalV3, closeModalV3 };
};
